module.exports = __webpack_public_path__ + "images/108_4096.jpg";